// Index - Scrolling Get Started Buttons
$(document).ready(function() {

    $('.get-started').click(function(){
        $('html, body').animate({
            scrollTop: $("#index-contact").offset().top
        }, 450);
     });
});
